import React from 'react'
import { navigate } from 'gatsby'
import { SEO, HideAtMobile, ShowAtMobile, LgWrapper } from '@raysync/common/components'
import Layout from '../components/layout'
import intl from 'react-intl-universal'

import { SectionWrapper, ExpandIcon, MobileMenuContainer, Container, NavWrap } from '../style/post.atom'
import { Menus } from '../components/menus/menus'
import { BreadCrumb2 } from '../components/bread-crumb/index'
import Article from '../components/article'
import { SearchInput } from '../components'
import RightIcon from '../images/right.png'

function Post({ location, pageContext }) {
  const [isExpand, setIsExpand] = React.useState(false)
  const { data } = pageContext
  const handleSearch = value => {
    if (!value) return
    navigate(`/support/search?keyword=${value}`)
  }
  const isVideoPage = data.type === 'video'
  return (
    <Layout location={location}>
      <SEO
        title={data.title || intl.get('support.seo.title')}
        description={intl.get('support.seo.keywords')}
        keywords={intl.get('support.seo.desc')}
      />
      <SectionWrapper>
        <LgWrapper>
          <Container top={20}>
            <ShowAtMobile>
              <MobileMenuContainer isExpand={isExpand}>
                <ExpandIcon
                  isExpand={isExpand}
                  onClick={() => {
                    setIsExpand(!isExpand)
                  }}
                >
                  <img src={RightIcon} alt='right icon' />
                </ExpandIcon>
                <Menus menus={data.menus} />
              </MobileMenuContainer>
            </ShowAtMobile>
            <HideAtMobile>
              <Menus menus={data.menus} />
            </HideAtMobile>
            <div>
              <NavWrap>
                <BreadCrumb2 slug={data.slug} menus={data.menus} title={data.title}></BreadCrumb2>
                <SearchInput handleSearch={handleSearch} />
              </NavWrap>
              <Article
                slug={data.slug}
                title={data.title}
                showHeaders={!isVideoPage}
                article={data.tinyContent && data.tinyContent.tinyContent}
              ></Article>
            </div>
          </Container>
        </LgWrapper>
      </SectionWrapper>
    </Layout>
  )
}

export default Post
